<template>
	<div class="footer">
		主办单位：常德市人民政府办公室<br />承办单位：常德市数据局（常德市行政审批服务局）
	</div>
</template>

<script>
</script>

<style>
</style>